interface IFormNames {
  [key: string]: Array<string>
}

class ToggleFormFields {
  container: HTMLElement
  formNames: IFormNames

  constructor(container: HTMLElement, formNames: IFormNames) {
    this.container = container
    this.formNames = formNames

    if (this.container && this.formNames) {
      this.toggle()
    }
  }

  private toggle() {
    const { container, formNames } = this
    const tabsInputs = container.querySelectorAll('.radio-group input') as NodeListOf<HTMLInputElement>
    const form = document.querySelector('form') as HTMLFormElement

    this.init(tabsInputs, form)

    tabsInputs.forEach(tabInput => {
      tabInput.addEventListener('change', () => {
        const value = tabInput.value

        if (value in formNames) {
          this.show(form, formNames, value)
        } else {
          this.hide(form, formNames)
        }
      })
    })
  }

  private show(form: HTMLFormElement, formNames: IFormNames, value: string) {
    formNames[value].forEach(name => {
      const input = form.querySelector(`[name="${name}"]`)

      if (input) {
        input.removeAttribute('disabled')
        input.closest('.form-field')?.classList.remove('is-hidden')
      }
    })
  }

  private hide(form: HTMLFormElement, formNames: IFormNames) {
    Object.values(formNames).forEach(value =>
      value.forEach((name: any) => {
        const input = form.querySelector(`[name="${name}"]`)

        if (input) {
          input.setAttribute('disabled', 'true')
          input.closest('.form-field')?.classList.add('is-hidden')
        }
      }),
    )
  }

  private init(tabsInputs: NodeListOf<HTMLInputElement>, form: HTMLFormElement) {
    const checkedInput = Array.from(tabsInputs).find(input => input.checked)

    if (checkedInput) {
      const { formNames } = this
      const value = checkedInput.value

      if (value in formNames === false) {
        this.hide(form, formNames)
      }
    }
  }
}

export default ToggleFormFields
